import templateUrl from 'emun.salesrep/manager-actions-rep.htm'
import basicController from 'servicestack/basic.controller.properties'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import salesrepConfig from 'emun.salesrep/salesrep.config'

class ManagerActionsRepController {
	constructor($window, $rootScope) {
		basicController(this)
		let $ctrl = this;
		$ctrl.actions = [];
		$ctrl.orderByField = salesrepConfig.ManagerActionRepOrderBy || 'SalesRepName';
		$ctrl.reverseSort = false;
		var timezone = moment.tz.guess();
		$ctrl.currentDate = moment.tz(timezone).format("DD/MM/YYYY");
	}
	$onInit() {
		let $ctrl = this;
		$ctrl.repGroupFilter = '';

		if ($ctrl.repGroup !== 'ALL' && $ctrl.repGroup !== '' && $ctrl.repGroup !== null) {
			$ctrl.repGroupFilter = '&RepGroupID=' + $ctrl.repGroup;
			$ctrl.salesRepQueryUrl = $ctrl.salesRepQueryUrl + '&RepGroupId=' + $ctrl.repGroup;
		}
		if ($ctrl.context === "manager") {
			$ctrl.salesRepQueryUrl = $ctrl.salesRepQueryUrl + '&ManagerId=' + $ctrl.repId;
		}

		var dashboardActivityType = salesrepConfig.dashboardActivityType || "Store Appointment";
		dashboardActivityType = dashboardActivityType.replace(" ", "%20");
		if ($ctrl.insideSales === 'true') {
			dashboardActivityType = 'Phone/Email&IsInsideSales=true';
		}

		var urlToRun = 'QueryRepThisWeekAction?DateRange=' + $ctrl.dateRange + '&ActivityType=' + dashboardActivityType + $ctrl.repGroupFilter;
		if ($ctrl.allReps) urlToRun = urlToRun + "&AllReps=true";

		$ctrl.query = new AutoQuery({
			url: urlToRun,
			orderBy: salesrepConfig.ManagerActionRepOrderBy || 'SalesRepName',
			autoLoad: true,
			pageSize: 12,
			append: false

		});

	}
}

let ManagerActionsRep = {
	bindings: {
		repGroup: '@',
		repId: '<',
		context: '@',
		insideSales: '@',
		widgetTitle: '@',
		dateRange: '@',
		dateSumRange: '@',
		allReps: '<'
	},
	controller: ManagerActionsRepController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
}


export default ManagerActionsRep;